import * as React from 'react';
import axios from 'axios';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext.js';
import Map, {
    Marker,
    Popup,
    NavigationControl,
    FullscreenControl,
    ScaleControl,
    GeolocateControl
} from 'react-map-gl/mapbox';

import Grid from '@mui/material/Grid';
import 'mapbox-gl/dist/mapbox-gl.css';
import EdonLogo from '../img/edon Connect Logo.png';
import EdonLogoSmall from '../img/edonConnectLogoSmall.png';


const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;

const pinContainerStyle = {
    position: 'relative',
    width: '30px',
    height: '30px',
    cursor: 'pointer'
  };
  
  const pinStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  };

const imgStyle = {
    position: 'absolute',
    top: '15%',
    left: '25%',
    width: '50%',
    height: '50%'
  };


function Pin() {
    return (
      <div style={pinContainerStyle}>
        <svg viewBox="0 0 24 24" style={pinStyle}>
          <path d={ICON} fill="#000" />
        </svg>
        <img src={EdonLogoSmall} alt="Edon Logo" style={imgStyle} />
      </div>
    );
  }


const MapGLView = () => {
    //SECTION USER CONTEXT and HEADERS
    const userData = useContext(UserContext);
    const storedHeaders = sessionStorage.getItem('headers');
    const headers = storedHeaders ? JSON.parse(storedHeaders) : {};
    // !SECTION

    React.useEffect(() => {
        getmarkers();
        }, []);

    const [popupInfo, setPopupInfo] = React.useState(null);
    const [markers, setMarkers] = React.useState([]);

    //get the warehouse markers from the API
    const getmarkers = async (user) => {
    var parameters = { itemNumber: "All"}; 
    await axios
    .get(
        `/Warehouses/warehousemappinginfo`,
        { headers: headers, params: parameters }
        )
        .then(function async(response) {
        //   console.log(response.data.message)
        setMarkers(response.data.message)
        })
        .catch(function (error) {
        if (error.response.status === 401) {
            alert ("Your session has expired. Please login again.");

        }
        if (error.response.status !== 401) {
            console.log(error.response.data.detail)
        }
        })
    };


  const pins = React.useMemo(
    () =>
      markers.map((index) => (
        <Marker
          key={`marker-${index.id} `}
          longitude={index.coordinates[0]}
          latitude={index.coordinates[1]}
          anchor="bottom"
          onClick={e => {
            // If we let the click event propagates to the map, it will immediately close the popup
            // with `closeOnClick: true`
            e.originalEvent.stopPropagation();
            setPopupInfo(index);
          }}
        >
          <Pin />
        </Marker>
      )),
    [markers]
  );


  return (
    <Grid container spacing={0}>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{  
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          border: 0,
          borderStyle: "dotted",
          borderRadius: "5px",
          marginTop: 1,
          padding: 1,
          paddingLeft: 1,

        }}
      >

        <Map
        mapboxAccessToken='pk.eyJ1IjoiZ29vZG1vbnN0ZXIiLCJhIjoiY202aHlkdXRpMDJwdDJsb3JycWZhMWV5ciJ9.SB84drGwNAQyliOyxWy4Zg'
        initialViewState={{
            longitude: -84.353217,
            latitude:  33.95759,
            zoom: 3
        }}
        style={{
            width: '100%', // Set the width of the map
            height: '600px', // Set the height of the map
            minHeight: '600px' // Ensure the minimum height is 600px
        }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        >

        <GeolocateControl position="top-left" />
        <FullscreenControl position="top-left" />
        <NavigationControl position="top-left" />
        <ScaleControl />

        {pins}

        {popupInfo && (
          <Popup
            anchor="top"
            longitude={Number(popupInfo.coordinates[0])}
            latitude={Number(popupInfo.coordinates[1])}
            onClose={() => setPopupInfo(null)}
          >
            <div style={{color: 'black' ,center: 'center'}}>
                <img src={EdonLogo} alt="Edon Logo" style={{ width: '50%', height: '50%' }} />
                <br />
                {popupInfo.warehouseName} -  {popupInfo.warehouseNumber}
                <br />
                {popupInfo.inventoryCount}
                <br />
                {popupInfo.addressGeo}
            </div>
          </Popup>
        )}


        </Map>

        </Grid>
    </Grid>


  );
}

export default MapGLView;